<div class="theme-custom">
  <div class="modal-header">
    <h5 *ngIf="shareStep === ShareStep.GetLink">Sharing {{reportType}} Report File</h5>
    <h5 *ngIf="shareStep === ShareStep.EmailLink">Email Share Link of {{ reportType.replace(' Coordination', '') }}
      Report
      File</h5>
    <h5 *ngIf="shareStep === ShareStep.CopyLink || shareStep === ShareStep.GeneratingLink">Shareable Link for {{reportType}} Report</h5>
    <button type="button" class="close" (click)="close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <p *ngIf="shareStep === ShareStep.GetLink" class="popup-body-font">Anyone receiving this link will be able to access
      the report.</p>
    <div *ngIf="shareStep === ShareStep.GeneratingLink">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <p class="cpw-text-base">Generating Link…</p>
    </div>

    <div *ngIf="shareStep === ShareStep.EmailLink">
      <div class="form-horizontal">
        <div class="form-group">
          <label for="sendEmail" class="c-field__label">Email addresses (separated by comma):</label>

          <input class="form-control" id="sendEmail" type="text" autocomplete="off" [(ngModel)]="email" />

          <!-- Required Error -->
          <span *ngIf="emailErrorRequired" style="color:red;">
            Email Address is required.
          </span>

          <!-- Invalid Email Format Error -->
          <span *ngIf="emailErrorInvalid" style="color:red;">
            Please enter valid email addresses separated by commas
          </span>
        </div>
      </div>

      <div class="form-horizontal">
        <div class="form-group">
          <label for="message" class="c-field__label">Message (optional):</label>
          <textarea class="form-control c-field-control" id="message" rows="4" [(ngModel)]="message"
            style="min-height: initial;height: 79px;">
      </textarea>
        </div>
      </div>

      <div class="form-horizontal" style="margin-top: 18px;">
        <div class="form-group c-choice--checkbox">
          <input id="chksendCopyToMe" name="chksendCopyToMe" class="c-choice__input" type="checkbox"
            [(ngModel)]="sendCopyToMe" />
          <label class="c-choice__label" for="chksendCopyToMe">Send a copy to myself</label>
        </div>
      </div>
    </div>
    <div *ngIf="shareStep === ShareStep.CopyLink">
      <div class="info-row" *ngIf="isLinkMessage">
        <i class="fa fa-info-circle info-icon"></i>
        <span>The link has already been copied to your clipboard.</span>
      </div>
      <div class="input-group margin-bottom-10">
        <input class="form-control" [value]="generatedLink" readonly>
        <span class="input-group-btn input-tooltip-btn">
          <button class="btn btn-primary" (mouseover)="onHover()" (mouseleave)="onLeave()" (click)="copyLink()"
            data-toggle="tooltip" data-placement="top" #copyBtn>
            <i [class]="isCopy ? 'fa fa-copy' : 'fa fa-check'"></i>
          </button>
        </span>
      </div>
    </div>
  </div>
  <div class="modal-footer share-report-dialog">
    <div *ngIf="shareStep === ShareStep.GetLink">
      <button class="btn btn-secondary" (click)="goToEmailStep()"><i class="fa fa-envelope me-2"
          style="vertical-align: unset !important;"></i> Email Link</button>
      <button class="btn btn-primary" (click)="startGenerateLink()"><i class="fa fa-share-alt me-2"></i> Get Share
        Link</button>
    </div>
    <div class="d-flex justify-content-between" style="display: flex !important"
      *ngIf="shareStep === ShareStep.EmailLink">
      <button class="btn btn-secondary" (click)="back()" style="display:flex;align-items:center;">
        <i class="fa fa-chevron-left me-2"></i> Go Back
      </button>
      <div>
        <button class="btn btn-secondary" (click)="close()">Close</button>
        <button class="btn btn-primary" (click)="sendEmail()"><i class="fa fa-paper-plane"></i> Send Email</button>
      </div>
    </div>

    <div class="d-flex justify-content-between" *ngIf="shareStep === ShareStep.CopyLink" style="display: flex !important">
      <button class="btn btn-secondary" (click)="back()" style="display:flex;align-items:center;">
        <i class="fa fa-chevron-left me-2"></i> Go Back
      </button>
      <div>
        <button class="btn btn-secondary" (click)="close()">Close</button>
        <button class="btn btn-primary" (click)="copyLink(); close();">Copy Link</button>
      </div>
    </div>

  </div>
</div>